import React from "react";
import { useTranslation } from 'react-i18next';
import ForgotPasswordForm from "../../../containers/user-management/ForgotPasswordForm/ForgotPasswordForm";
import {
  Wrapper,
  Header,
  Title,
  SubTitle,
  Card,
  Text,
  BackLink,
  Logo
} from "../styles";
import PageWrapper from "../../../components/PageWrapper/PageWrapper";
import LanguageDropdown from "../../../components/LanguageDropdown";

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  return (
    <PageWrapper>
      <LanguageDropdown />
      <Wrapper>
        <Header>
          <Logo src="/logo.png" alt="Offolio Logo" />
          <SubTitle>{t('forgotPasswordPage.title')}</SubTitle>
          <Text>{t('forgotPasswordPage.subtitle')}</Text>
        </Header>

        <Card>
          <ForgotPasswordForm />
        </Card>
      </Wrapper>
    </PageWrapper>
  );
};

export default ForgotPasswordPage;
